export const RADIO_STREAM_URL = 'https://tabtouch.senstreams.com.au/playlist.m3u8'
